const PERMISSION_KEY= "core:authz_permission_group";
const PAGE_URL = {
    AUTHZ_PERMISSION_GROUP_PAGE: "/admin/core/authz-permission-group"
}

export {PERMISSION_KEY, PAGE_URL}

